import { UIService } from './../services/UIService'
import { CombinedVueInstance } from 'vue/types/vue'
import { SysInfo } from './SysInfo'
import { UIOptions } from './UIOptions'

export class SharedVariable {
  vue: CombinedVueInstance<Vue, object, object, object, Record<never, any>>
  sysInfo: SysInfo
  uiService: UIService
  options: UIOptions
}
